import React, { useContext, useState, useEffect } from 'react';
import { InputContext } from '../contexts/InputContext';
import { useNavigate } from "react-router-dom";

const Salir = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)

  useEffect(() => {
    localStorage.removeItem('token');
    setAuthInformation({token: undefined, rol: undefined, autenticado: false})
  }, []);

  useEffect(() => {
    if(authInformation.autenticado === true){
      navigate(`/`);
    }

  }, [authInformation]);

  return (
    <div>
      {(authInformation.autenticado === false) && (
        <main className="w-100 m-auto" style={{maxWidth: '330px'}}>
          <h1 className="h3 mb-3 fw-normal">Gracias por utilizar este servicio</h1>
        </main>
      )}
    </div>
  );
};

export default Salir;